import { render } from "./ResultTableItemMobile.vue?vue&type=template&id=115ef48c&scoped=true"
import script from "./ResultTableItemMobile.vue?vue&type=script&lang=js"
export * from "./ResultTableItemMobile.vue?vue&type=script&lang=js"

import "./ResultTableItemMobile.vue?vue&type=style&index=0&id=115ef48c&scoped=true&lang=css"
import "./ResultTableItemMobile.vue?vue&type=style&index=1&id=115ef48c&lang=css"

import exportComponent from "C:\\AgentIFAS\\_work\\33\\s\\Nezivotko.Web2\\CreditWorthiness\\real-world-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-115ef48c"]])

export default __exports__